import api from '..'

const getCoursesCounters = () => {
  return api.get(`/courses/counters`).then(({ data }) => {
    return data
  })
}

export default getCoursesCounters
